import React from 'react';

import { token } from '@atlaskit/tokens';
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

export default (): JSX.Element => {
  return (
    <svg
      width={16}
      height={18}
      viewBox="0 0 16 18"
      style={{ marginLeft: token('space.negative.050', '-4px') }}
    >
      <path
        d="M3.697 9.196c0-1.104.902-2 2.008-2h7.983a2 2 0 012.009 2v6.001c0 1.104-.902 2-2.009 2H5.705a2 2 0 01-2.008-2V9.196zM8 7H6V4.002A2.001 2.001 0 004 2c-1.102 0-2 .898-2 2.002V7H0V4.002a4 4 0 118 0V7zm1.697 7.197a2 2 0 100-4 2 2 0 000 4z"
        fill="#505F79"
        fillRule="evenodd"
      />
    </svg>
  );
};
